export default __webpack_public_path__ + "static/topo-404e82bacb9c975bdd0d16c4b7e07330.jpg";